<template>
  <div class="container-fluid">
    <div class="row mb-3" v-if="isKeys || isAddOrEdit">
      <div
        class="col-1"
        @click="
          setIsKeys(false);
          setIsAddOrEdit(false);
        "
      >
        <i class="fa fa-arrow-left fa-2x"></i>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row" v-if="isKeys">
          <div class="col">
            <div class="card">
              <div class="card-body">
                <div
                  class="alert alert-danger"
                  role="alert"
                  v-if="keys.private_key"
                >
                  <div class="alert-message fs-3" style="color: var(--bs-red)">
                    <strong style="color: var(--bs-red)">{{
                      $t("gpool.warning")
                    }}</strong>
                    <span>
                      {{ $t("gpool.private_key_warning") }}
                    </span>
                  </div>
                </div>
                <div v-if="keys.private_key" class="mb-3">
                  <strong>Private Key:</strong>
                  <span id="private_key">{{ keys.private_key }}</span>
                  <button
                    class="btn btn-link"
                    @click="clickToCopy('private_key')"
                  >
                    <i class="fa fa-copy" v-if="!copied"></i>
                    <i
                      class="fa fa-check"
                      style="color: var(--bs-green)"
                      v-else-if="copied == 1"
                    ></i>
                    <i
                      class="fa fa-times"
                      style="color: var(--bs-red)"
                      v-else-if="copied == 2"
                    ></i>
                  </button>
                </div>
                <div v-if="keys.public_key">
                  <strong>Public Key:</strong>
                  <span id="public_key">{{ keys.public_key }}</span>
                  <button
                    class="btn btn-link"
                    @click="clickToCopy('public_key')"
                  >
                    <i class="fa fa-copy" v-if="!copied"></i>
                    <i
                      class="fa fa-check"
                      style="color: var(--bs-green)"
                      v-else-if="copied == 1"
                    ></i>
                    <i
                      class="fa fa-times"
                      style="color: var(--bs-red)"
                      v-else-if="copied == 2"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="isAddOrEdit">
          <div class="col-lg-8 offset-lg-2">
            <form @submit.prevent="saveSite(site)">
              <div class="card mt-0">
                <div class="card-header">
                  <span v-if="site.id">
                    {{ $t("gpool.edit_site") }}: {{ site.name }}
                  </span>
                  <span v-else>{{ $t("gpool.create_site") }}</span>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-3">
                        <label class="form-label" for="name">
                          {{ $t("gpool.form_name") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="posting"
                          v-model="site.name"
                        />
                      </div>
                      <div class="col-9">
                        <label class="form-label" for="domain">
                          {{ $t("gpool.form_domain") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="posting"
                          v-model="site.domain"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button
                    :disabled="posting"
                    type="submit"
                    class="btn"
                    :class="{
                      'btn-success': !site.id,
                      'btn-primary': site.id,
                    }"
                  >
                    <i v-if="posting" class="fa fa-spinner fa-spin"></i>
                    <template v-else>
                      <span v-if="site.id">
                        {{ $t("gpool.form_update") }}
                      </span>
                      <span v-else>
                        {{ $t("gpool.form_add") }}
                      </span>
                    </template>
                  </button>
                  <button class="btn btn-link" @click="setIsAddOrEdit(false)">
                    {{ $t("gpool.form_cancel") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="position-relative card mt-0" v-else>
          <div class="card-header">
            <div class="align-items-center row">
              <div class="col-6">
                <div class="mb-0 card-title h5">
                  {{ $t("gpool.menu_sites") }}
                </div>
              </div>
              <div class="text-end col-6" @click="setIsAddOrEdit(true)">
                <button type="button" class="btn btn-primary">
                  <i class="fa fa-plus"></i>
                  <span class="ms-2 align-middle">{{
                    $t("gpool.create_site")
                  }}</span>
                </button>
              </div>
            </div>
          </div>
          <div
            class="rounded-0 position-absolute w-100 progress"
            style="height: 6px"
            v-if="loading"
          >
            <div
              role="progressbar"
              class="progress-bar progress-bar-animated progress-bar-striped"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 100%"
            ></div>
          </div>
          <div v-else-if="!sites.length" class="text-center p-4">
            {{ $t("gpool.no_data") }}
          </div>
          <table v-else class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th width="100%">{{ $t("gpool.table_name") }}</th>
                <th class="text-center">{{ $t("gpool.table_status") }}</th>
                <th class="text-center">{{ $t("gpool.table_actions") }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="site in sites">
                <td>{{ site.id }}</td>
                <td>
                  <strong>{{ site.name }}</strong>
                  <span class="d-block small text-muted">
                    {{ site.domain }}
                  </span>
                </td>
                <td class="text-center">
                  <div class="form-switch" @click="toggleStatus(site)">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="status"
                      style="pointer-events: none"
                      :disabled="statusing"
                      :checked="site.status"
                    />
                  </div>
                </td>
                <td class="text-center">
                  <div role="group" class="btn-group">
                    <button
                      type="button"
                      class="btn"
                      @click="editSite(site.id)"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      @click="deleteSite(site.id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button type="button" class="btn" @click="getKeys(site.id)">
                      <i class="fa fa-key"></i>
                    </button>
                  </div>
                </td>
                <td style="display: flex">
                  <router-link
                    tag="button"
                    :to="`/sites/${site.id}/urls`"
                    class="btn btn-warning mx-2"
                  >
                    {{ $t("gpool.table_urls") }}
                  </router-link>
                  <router-link
                    tag="button"
                    :to="`/sites/${site.id}/users`"
                    class="btn btn-info mx-2"
                  >
                    {{ $t("gpool.table_users") }}
                  </router-link>
                  <router-link
                    tag="button"
                    :to="`/sites/${site.id}/games`"
                    class="btn btn-secondary mx-2"
                  >
                    {{ $t("gpool.table_games") }}
                  </router-link>
                  <router-link
                    tag="button"
                    :to="`/sites/${site.id}/tournaments`"
                    class="btn btn-success ms-2"
                  >
                    {{ $t("gpool.table_tournaments") }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="card-footer"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Sites",
  computed: {
    ...mapGetters("site", [
      "sites",
      "site",
      "loading",
      "posting",
      "isAddOrEdit",
      "statusing",
      "keys",
      "isKeys",
    ]),
  },
  beforeDestroy() {
    this.setLoading(true);
    this.setIsAddOrEdit(false);
    this.setIsKeys(false);
    this.resetKeys();
  },
  async mounted() {
    this.getSites();
  },
  methods: {
    clickToCopy(elementId) {
      if (this.copied > 0) return (this.copied = 0);
      var self = this;
      var textToCopy = document.getElementById(elementId).textContent;

      navigator.clipboard
        .writeText(textToCopy)
        .then(function () {
          // Successful copy
          self.copied = 1;
        })
        .catch(function (err) {
          // Handle error if copy fails
          self.copied = 2;
        });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.site.logo = file;
    },
    ...mapActions("site", [
      "getSites",
      "saveSite",
      "setIsAddOrEdit",
      "toggleStatus",
      "editSite",
      "deleteSite",
      "updateOrder",
      "setLoading",
      "getKeys",
      "setIsKeys",
      "resetKeys",
    ]),
  },
  data() {
    return {
      copied: 0,
    };
  },
};
</script>

<style>
#public_key,
#private_key {
  background-color: #eee;
  padding: 5px 10px;
  color: #b90404;
  font-family: monospace;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Sites.vue